import React, { CSSProperties, ReactNode } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import styles from './DeleteLibraryAdminDialog.module.css';
import { useDeleteLibraryAdminsMutation } from '../../../generated/graphql';

type DeleteLibraryAdminDialogProps = {
    onClose: () => void,
    libraryId: string,
    ids: string[],
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const DeleteLibraryAdminDialog = (props: DeleteLibraryAdminDialogProps) => {
    const { libraryId, ids, style, visible, onClose } = props;
    const [deleteLibraryAdmins, deleteLibraryAdminsResult] = useDeleteLibraryAdminsMutation({
        variables: {
            id: libraryId,
            ids: ids
        }
    });
    const handleOnYesClick = () => {
        deleteLibraryAdmins()
            .then(res => onClose())
            .catch(err => { });
    };
    return (
        <DialogBase
            title="Delete Library Admin"
            type="YesNo"
            isLoading={deleteLibraryAdminsResult.loading}
            visible={visible}
            onClose={onClose}
            onYesClick={handleOnYesClick}
            className={styles.DeleteClientAdminDialog}
            style={style}
            data-testid="DeleteClientAdminDialog">
            <p style={{ color: "var(--text-secondary)" }}>Are you sure you want to delete this admin?</p>
        </DialogBase>
    );
};

export default DeleteLibraryAdminDialog;